import { useEffect } from 'react';
import { osName } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

function HandleQRCodePage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (osName == 'iOS' || osName == 'Android') {
      window.location.href =
        osName === 'Android'
          ? 'https://play.google.com/store/apps/details?id=com.generali.allinone'
          : 'https://apps.apple.com/hk/app/generali-genbravo/id1607457003';
      return;
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return <></>;
}

export default HandleQRCodePage;
